import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EffectRef,
  input,
  InputSignal, output, OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import { PatientListItem, PatientTableItem } from "@shared/interfaces/paciente.interface";
import { MatIcon } from "@angular/material/icon";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'soph-tabla-pacientes',
  standalone: true,
  imports: [
    MatIcon,
    DatePipe
  ],
  templateUrl: './tabla-pacientes.component.html',
  styleUrl: './tabla-pacientes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    style: 'min-width: 862px'
  }
})
export class TablaPacientesComponent {

  public patientsOriginalList: InputSignal< PatientListItem[] > = input( [] as PatientListItem[] );
  public patients: WritableSignal< PatientTableItem[] > = signal< PatientTableItem[] >( [] as PatientTableItem[] );

  public onSelect: OutputEmitterRef<PatientTableItem> = output();

  updatedListEffect: EffectRef = effect(() => {
    const patients: PatientTableItem[] = this.patientsOriginalList().map( patient => {
      const { paciente, ultimaConsulta } = patient;
      const { idPaciente, nombres, apellidos, numeroDocumento } = paciente;
      const { inicioAtencion } = ultimaConsulta;
      return { id: idPaciente, completeName: `${nombres} ${apellidos}`, documentNumber: numeroDocumento, date: inicioAtencion };
    });
    this.patients.set( patients );
  }, { allowSignalWrites: true });

  onPatientHistoryClick( patient: PatientTableItem ) {
    this.onSelect.emit( patient );
  }

}
